import { useState } from "react";
import CenteredModal from "components/core/basic/CenteredModal";
import { Button } from "components/core/basic/Button";
import { Link } from "react-router-dom";
import { trellisPalette } from "components/custom/analytics/palettes";
import moment from "moment";
import { useLocalStorage } from "usehooks-ts";

const ExtensionInfo = () => {
  const [show, setShow] = useState(true);
  const [isDismissed, setIsDismissed] = useLocalStorage("dismiss_chrome_extension_help_banner", false);

  if (
    !localStorage.extensionSignup ||
    (localStorage.extensionSignup && isDismissed) ||
    !moment(localStorage.extensionSignup).isSame(moment(), "day")
  ) {
    return null;
  }

  return (
    <CenteredModal
      show={show}
      closeModal={() => {
        setShow(false);
        setIsDismissed(true);
      }}
      title={"Getting Started"}
      dialogClassName={"modal-60w"}
      style={{
        marginTop: "2rem",
      }}
    >
      <p className="my-4 w-75 mx-auto text-start">
        You’ve connected your Amazon store with the Trellis Seller Extension.
      </p>
      <p className="my-4 w-75 mx-auto text-start">
        To get started, head over to Amazon. You’ll begin to pull information about your competitors right into your
        browser.
      </p>
      <p className="my-4 w-75 mx-auto text-start">
        <Link
          style={{ color: trellisPalette[13], fontWeight: 500 }}
          to={{ pathname: "https://gotrellis.com/resources/blog/trellis-chrome-extension-guide/" }}
          target="_blank"
        >
          This article
        </Link>{" "}
        explains more how to get the most out of the Trellis Seller Extension.
      </p>
      <div className="d-flex justify-content-center py-4">
        <Button onPress={() => setIsDismissed(true)}>Get Started</Button>
      </div>
    </CenteredModal>
  );
};

export default ExtensionInfo;
